(function($) {
	'use strict';

	$.widget('msv.scrollup', {

		options: {},

		_create: function() {
			$(".scrollup").click(function() {
				$('html, body').animate({
					scrollTop: 0
				}, 800);
			});
		}

	});

})(jQuery);